import "./globals.css";
import ProductSpotlight from "./components/ProductSpotlight/ProductSpotlight";

function App() {
  return (
    <div className="App">
      <ProductSpotlight />
    </div>
  );
}

export default App;
